import { render } from "./release.vue?vue&type=template&id=57ca872a&scoped=true&bindings={\"topImg\":\"data\",\"leftnavIcon1\":\"data\",\"leftnavIcon2\":\"data\",\"questionIcon1\":\"data\",\"questionIcon2\":\"data\",\"changeContent\":\"data\"}"
import script from "./release.vue?vue&type=script&lang=js"
export * from "./release.vue?vue&type=script&lang=js"

import "./release.vue?vue&type=style&index=0&id=57ca872a&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-57ca872a"

export default script